import { ExtendedLookupValue, ExtendedLookupSearchValueOption } from '../types';

const getFormattedValue = <T>(
    value?: ExtendedLookupValue<T | string> | null,
): ExtendedLookupValue<T | string> | undefined => {
    if (!value) return undefined;

    if (value && (value as ExtendedLookupSearchValueOption).isSearchOption) {
        return {
            ...value,
            label: value.value as string,
        };
    }

    return value as ExtendedLookupValue<T>;
};

export default getFormattedValue;
